function showScrollToEnter(){
    
    const square = document.querySelector('.cursor__square');
    const scrollToEnter = document.querySelector('.cursor__scrollToEnter');

    square.classList.remove('block')
    square.classList.add('hidden')
    scrollToEnter.classList.remove('hidden')
    scrollToEnter.classList.add('block')
}
function showSquare(){
  
    const square = document.querySelector('.cursor__square');
    const scrollToEnter = document.querySelector('.cursor__scrollToEnter');
   
    square.classList.remove('hidden')
    square.classList.add('block')
    scrollToEnter.classList.remove('block')
    scrollToEnter.classList.add('hidden')
    
}

export {showScrollToEnter,showSquare}